/** Retrocession rates are stored as a fraction (0.77), displayed as both. */
const PERCENT_FACTOR = 100;

/** Decimals kept on the ratio, matching the contract detail page. */
const RATIO_DECIMALS = 2;

/** A retrocession rate rendered both as a percentage and as a raw ratio. */
export type RetrocessionRateLabels = {
  /** e.g. `"77%"`. */
  percent: string;
  /** e.g. `"0.77"`. */
  ratio: string;
};

/**
 * Formats a retrocession rate for display. The API sends it as a fraction, and
 * the sheets show the percentage first with the raw ratio in parentheses.
 *
 * @param rate - the rate as a fraction, as a number or a numeric string
 * @returns the percentage and ratio labels, or `null` when the rate is unusable
 */
export const formatRetrocessionRate = (
  rate: number | string | null | undefined,
): RetrocessionRateLabels | null => {
  if (rate === null || rate === undefined || rate === '') {
    return null;
  }

  const value = Number(rate);
  if (Number.isNaN(value)) {
    return null;
  }

  return {
    percent: `${Math.round(value * PERCENT_FACTOR)}%`,
    ratio: value.toFixed(RATIO_DECIMALS),
  };
};
